<template>
    <div class="eval">
        <div class="eval_title">
            <span>{{$t('eval_submit')}}</span>
            <span class="eval_close" @click="close()"></span>
        </div>
        <div class="eval_body" v-if="connectStatus === 'robot'">
            <p class="eval_desc">{{$t('eval_desc')}}</p>
            <div class="row row--resolve">
                <div :class=" type ? 'item good active' :'item good'" @click="chooseType(1)">
                    <span class="eval_icon "></span>
                    {{ $t('solved') }}
                </div>
                <div :class=" type ? 'item bad' :'item bad active'" @click="chooseType(0)">
                    <span class="eval_icon "></span>
                    {{ $t('noSolved') }}
                </div>
            </div>
            <p class="eval_desc">{{ $t('leaveTip') }}</p>
            <div class="row row--tags">
                <div :class="suggestion[0].value?'active item':'item'" @click="chooseSuggestion(0)">
                    {{ suggestion[0].name }}
                </div>
                <div :class="suggestion[1].value?'active item':'item'" @click="chooseSuggestion(1)">
                    {{ suggestion[1].name }}
                </div>
            </div>
            <div class="row row--tags">
                <div :class="suggestion[2].value?'active item':'item'" @click="chooseSuggestion(2)">
                    {{ suggestion[2].name }}
                </div>
                <div :class="suggestion[3].value?'active item':'item'" @click="chooseSuggestion(3)">
                    {{ suggestion[3].name }}
                </div>
            </div>
            <textarea v-model="suggester" maxlength="64" :placeholder="$t('leaveInput')" onresize="false"></textarea>
            <Button @click="submitEvaluate" style="background:#7467F0" type="default" size="normal">{{ $t('submit') }}
            </Button>
        </div>
        <div class="eval_body manual" v-if="connectStatus !== 'robot' && evaluateData.starList">
            <div class="row row--resolve" style="margin-top: 20px" v-if="evaluateData.evaluateAdminSolve">
                <div :class=" type ? 'item good active' :'item good'"
                     :style="{ backgroundColor: (type ? initData.kitBgcolor:'white')}"
                     @click="chooseType(1)">
                    <span class="eval_icon "></span>
                    {{ $t('solved') }}
                </div>
                <div :class=" type ? 'item bad' :'item bad active'"
                     :style="{ backgroundColor: (!type ? initData.kitBgcolor:'white')}"
                     @click="chooseType(0)">
                    <span class="eval_icon "></span>
                    {{$t('noSolved')}}
                </div>
            </div>
            <div class="row row--stars" v-if="evaluateData.evaluateModel !== 2">
                <div class="star_list">
                    <span :class="star >= 1 ? 'star active':'star'" @click="chooseStar(1)"></span>
                    <span :class="star >= 2 ? 'star active':'star'" @click="chooseStar(2)"></span>
                    <span :class="star >= 3 ? 'star active':'star'" @click="chooseStar(3)"></span>
                    <span :class="star >= 4 ? 'star active':'star'" @click="chooseStar(4)"></span>
                    <span :class="star === 5 ? 'star active':'star'" @click="chooseStar(5)"></span>
                </div>
            </div>
            <div>
                <p :style="{ color: initData.kitBgcolor }">{{ evaluateData.starList[star - 1].levelGuideMsg }}</p>
            </div>
            <div class="row row--tags" v-if="star !== 5">
                <div v-for="(target,index) in evaluateData.starList[star-1].select" v-if="target.name"
                     :key="target.name+Math.random()*100"
                     :style="{ backgroundColor: (target.value ? initData.kitBgcolor:'white'),color: (target.value ? 'white':initData.kitBgcolor) }"
                     class="item" @click="chooseAdvice(target)">
                    {{ target.name }}
                </div>
            </div>


            <textarea v-if="star !== 5" v-model="suggester" maxlength="64" :placeholder="evaluateData.starList[star-1].evaluateGuideMsg"
                      onresize="false"></textarea>
            <Button @click="submitEvaluate" style="background:#7467F0" type="default" size="normal">{{ $t('submit') }}
            </Button>
        </div>
    </div>
</template>

<script>
    import {Button, Toast} from 'mint-ui';
    import language from "../../store";
    import chatApi from "../methods";

    export default {
        name: "evaluate",
        data() {
            return {
                type: 1, // 机器人是否解决
                star: 5,// 默认5分
                suggestion: [
                    {name: this.$t('robotEva1'), value: 0},
                    {name: this.$t('robotEva2'), value: 0},
                    {name: this.$t('robotEva3'), value: 0},
                    {name: this.$t('robotEva4'), value: 0}
                ],
                advice: [
                    {name: this.$t('customerEva1'), value: 0},
                    {name: this.$t('customerEva2'), value: 0},
                    {name: this.$t('customerEva3'), value: 0},
                    {name: this.$t('customerEva4'), value: 0}
                ],
                suggester: '',
            }
        },
        mounted() {
        },
        components: {
            Button
        },
        computed: {
            initData() {
                return this.$store.state.initData
            },
            connectStatus() {
                return this.$store.state.connectStatus
            },
            evaluateData() {
                return this.$store.state.evaluateData
            },
        },
        watch: {
            connectStatus() {
                return this.$store.state.connectStatus
            },
            evaluateData() {
                return this.$store.state.evaluateData
            },

        },
        methods: {
            // 选中建议
            chooseSuggestion(index) {
                this.suggestion[index].value = !this.suggestion[index].value;
            },
            // 人工建议
            chooseAdvice(obj) {
                obj.value = !obj.value;
            },
            // 更改评分
            chooseStar(star) {
                this.star = star;
                this.advice.forEach(sug => {
                    sug.value = 0
                })
                this.suggester = '';
            },
            chooseType(type) {
                this.type = type
            },
            close() {
                this.$emit('closePopup')
            },
            submitEvaluate() {
                let param = {}
                if (this.$store.state.connectStatus === 'robot') {
                    let arr = [];
                    this.suggestion.forEach(sug => {
                        if (sug.value) {
                            arr.push(sug.name)
                        }
                    })
                    param.evaluateRobotTag = arr.join(',')
                    param.evaluateRobotSolve = this.type
                    param.evaluateRobotMode = 1;
                    param.evaluateRobotContent = this.suggester; //评价客服内容，长度最大64

                } else {
                    let arr = [];
                    this.evaluateData.starList[this.star - 1].select.forEach(item => {
                        if (item.value) {
                            arr.push(item.name)
                        }
                    })
                    if (this.evaluateData.starList[this.star - 1].evaluateMsgRequired && !this.suggester) {
                        // 必填评价
                        Toast({
                            message: this.$t('evaConInput'),
                            duration: 3000
                        });
                        return
                    }
                    if (this.evaluateData.starList[this.star - 1].levelTagRequired && arr.length === 0) {
                        // 必填评价
                        Toast({
                            message: this.$t('evaLabelSelect'),
                            duration: 3000
                        });
                        return
                    }
                    param.evaluateAdminSolve = this.type;
                    param.evaluateAdminMode = 1;
                    param.evaluateAdminContent = this.suggester; //评价客服内容，长度最大64
                    param.evaluateAdminStar = this.star; //客服评价星级
                    param.evaluateAdminTag = arr.join(',');  //客服评价标签，多个逗号分隔，长度最大64
                }
                chatApi.sendEvaluate(param)
                this.$emit('closePopup')
            }
        },

    }
</script>

<style scoped>
    .eval {
        background: white;
        min-height: 240px;
        width: 100%;
    }

    .eval_title {
        height: 44px;
        background: #f5f6f9;
        color: #2a2a2c;
        font-size: 14px;
        text-align: left;
        position: relative;
    }

    .eval_title span {
        margin: 5px 15px;
        display: inline-block;
        line-height: 34px;
        text-align: left;
    }

    .eval_close {
        position: absolute;
        right: 5px;
        top: 8px;
        font-size: 20px;
        width: 25px;
        color: #999;
        height: 25px;
        margin: 0 !important;
    }

    .eval_close::before {
        content: "\2716";
    }

    .eval_body {
        margin: 0 30px 38px;
        text-align: left;
        min-height: 150px;
        position: relative;
        padding-bottom: 64px;
    }

    .eval_body button {
        position: absolute;
        bottom: 0;
        background: #7467F0;
        color: #ffffff;
        font-size: 14px;
        width: 100%;
        left: 0;
    }

    .eval_desc {
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        margin: 10px;
    }

    .eval_body .item.active {
        color: white;
        /*background: #7467F0;*/
        border: 1px solid white;
    }

    textarea {
        width: 100%;
        height: 100px;
        color: #999999;
        border: .5px solid #B3B3B3;
        font-size: 14px;
        resize: none;
        padding: 5px;
    }

    .manual .star {
        display: inline-block;
        width: 50px;
        height: 50px;
        background-image: url("../../../static/image/star.png");
        background-size: 100% 100%;
        cursor: pointer;
    }

    .manual .star.active {
        background-image: url("../../../static/image/starActive.png");
    }

    .manual p {
        font-size: 14px;
        color: #7467F0;
        text-align: center;
        margin: 10px;
    }

    .star_list {
        margin: 10px auto;
    }

    /* iframe / 窄屏：全局 .row { flex-wrap:wrap } + div.item 固定 148px + 50px 星会导致换行、叠字 */
    .eval_body .row--resolve,
    .manual .row--stars {
        flex-wrap: nowrap;
        justify-content: stretch;
        gap: 8px;
    }

    .eval_body .row--resolve .item.good,
    .eval_body .row--resolve .item.bad {
        width: auto !important;
        flex: 1 1 0;
        min-width: 0;
        padding: 0 4px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .manual .row--stars .star_list {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        gap: 2px;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .manual .row--stars .star {
        flex: 0 0 auto;
        width: 40px;
        height: 40px;
        max-width: calc((100% - 16px) / 5);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

    @media screen and (max-width: 360px) {
        .eval_body {
            margin-left: 12px;
            margin-right: 12px;
        }

        .manual .row--stars .star {
            width: 32px;
            height: 32px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/h5/evaluate.vue